import {
  COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED,
  COMBINED_RESULTS_LOADED,
  COMBINED_ENTRY_PAGE_LOADED,
  CONFIG_SCREEN_LANDING,
  DETAILS_PANEL_LOADED,
  FLIGHTS_DAY_VIEW_RESULT_SELECTED,
  FLIGHTS_DAYVIEW_ITINERARIES_RENDERED,
  FLIGHTS_DAYVIEW_RENDERED,
  HOMEPAGE_LOADED,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';
import { SCREEN_NAMES } from '@web-platform/shared-universal-constants/src/screenName';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { TrustedFunnelState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/trustedFunnel';

const trustedFunnel = (
  // FIXME: SHIBA-809 Bad typecasting - do not copy this pattern
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  state: TrustedFunnelState = {} as TrustedFunnelState,
  action: Action,
): TrustedFunnelState => {
  switch (action.type) {
    case HOMEPAGE_LOADED: {
      return {
        ...state,
        viewGuid: action.payload.viewGuid,
        currentScreenName: SCREEN_NAMES.HOME_PAGE,
      };
    }

    case COMBINED_RESULTS_LOADED: {
      return {
        ...state,
        viewGuid: action.payload.viewGuid,
        searchEventGuid: action.payload.searchEventGuid,
        currentScreenName: SCREEN_NAMES.COMBINED_RESULTS,
      };
    }

    case COMBINED_ENTRY_PAGE_LOADED: {
      return {
        ...state,
        viewGuid: action.payload.viewGuid,
        searchEventGuid: action.payload.searchEventGuid,
        currentScreenName: SCREEN_NAMES.COMBINED_ENTRY_PAGE,
      };
    }

    case DETAILS_PANEL_LOADED: {
      return {
        ...state,
        viewGuid: action.payload.viewGuid,
        searchResultsPageGuid: action.payload.searchResultsPageGuid,
        searchResultsOptionGuid: action.payload.searchResultsOptionGuid,
        searchResultSelectedGuid:
          action.payload.searchResultSelectedGuid ?? state.searchResultSelectedGuid,
        currentScreenName: SCREEN_NAMES.DETAILS_PANEL,
      };
    }

    case FLIGHTS_DAYVIEW_RENDERED: {
      return {
        ...state,
        viewGuid: action.payload.viewId ?? state.viewGuid,
        searchEventGuid: action.payload.viewId ?? state.searchEventGuid,
        currentScreenName: SCREEN_NAMES.DAY_VIEW,
      };
    }

    // Acorn specific action to set viewGuid and searchEventGuid when the booking panel screen is entered, before DetailsPanel lazy-loads.
    case CONFIG_SCREEN_LANDING: {
      return {
        ...state,
        viewGuid: action.payload.viewId ?? state.viewGuid,
        searchEventGuid: action.payload.viewId ?? state.searchEventGuid,
        ...(action.payload.searchResultsPageGuid && {
          searchResultsPageGuid: action.payload.searchResultsPageGuid,
        }),
      };
    }

    // Acorn specific action to set the searchResultsPageGuid at day-view results-render time.
    case FLIGHTS_DAYVIEW_ITINERARIES_RENDERED: {
      if (action.payload.searchResultsPageGuid) {
        return {
          ...state,
          searchResultsPageGuid: action.payload.searchResultsPageGuid,
        };
      }
      return state;
    }

    // Banana specific action to set the searchResultsPageGuid at combined-results-render time.
    case COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED: {
      if (action.payload.searchResultsPageGuid) {
        return {
          ...state,
          searchResultsPageGuid: action.payload.searchResultsPageGuid,
        };
      }
      return state;
    }

    // Acorn specific action to set the searchResultsOptionGuid when a day-view result is selected.
    case FLIGHTS_DAY_VIEW_RESULT_SELECTED: {
      if (action.payload.searchResultsOptionGuid) {
        return {
          ...state,
          searchResultsOptionGuid: action.payload.searchResultsOptionGuid,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default trustedFunnel;
export const get = (state: TrustedFunnelState): TrustedFunnelState => state;
